import { Suspense, lazy } from 'react';

const GeniaAuth = lazy(() => import('@/microfrontends/cliengo-auth'));

const authMicrofrontRoutes = [
  '/login',
  '/signup',
  '/reset-password',
  '/password-change',
  '/terms',
  '/privacy',
  '/process-social-login',
];

export const authRoutes = authMicrofrontRoutes.map((route) => ({
  path: route,
  element: (
    <Suspense fallback={<p>...</p>}>
      <GeniaAuth />
    </Suspense>
  ),
}));
